import { Typography } from '@mui/material';

const HeroContent = () => {
  return (
    <>
      <Typography
        sx={(theme) => ({
          typography: {
            xs: 'display2',
            sm: 'display1',
          },
          color: theme.palette.default.contrastText,
          margin: 0,
          width: { xs: '330px', sm: '625px', md: '700px' },
        })}>
        Connecting families with quality, local caregivers
      </Typography>
    </>
  );
};

export default HeroContent;
